import { useColorModeValue } from "@/components/ui/color-mode"
import { effects } from "@/theme"
import { Box, type BoxProps } from "@chakra-ui/react"
import { type ReactNode, forwardRef } from "react"

export interface GradientBorderProps extends BoxProps {
  children: ReactNode
  borderWidth?: string
  borderRadius?: string
  gradient?: string
}

export const GradientBorder = forwardRef<HTMLDivElement, GradientBorderProps>(
  (
    {
      children,
      borderWidth = "1px",
      borderRadius = "20px",
      gradient,
      ...props
    },
    ref,
  ) => {
    const isLight = useColorModeValue(true, false)
    const defaultGradient = isLight
      ? "linear-gradient(135deg, #E2E8F0, #CBD5E0)"
      : effects.gradients.borderGradient
    const innerBg = isLight ? "white" : undefined

    return (
      <Box
        ref={ref}
        position="relative"
        borderRadius={borderRadius}
        padding={borderWidth}
        background={gradient || defaultGradient}
        {...props}
      >
        <Box
          borderRadius={borderRadius}
          background={innerBg || "bg.glass"}
          backdropFilter={isLight ? "none" : "blur(20px)"}
          height="100%"
          width="100%"
          overflow="hidden"
        >
          {children}
        </Box>
      </Box>
    )
  },
)

GradientBorder.displayName = "GradientBorder"
